import { useSelector } from 'react-redux';

import { DEFAULT_COUNTRY } from './useUserCountryRelatedInfo';
import { Country, Locale, Territory } from '../@types/country';
import { getUserCountry } from '../modules/user';

const useInitialCountryLocale = (): { country: Country; locale: Locale; territory: Territory } => {
	const useCountry = useSelector(getUserCountry);
	const defaultWebCountry: Country | undefined = process.env.MOB_APP_BUILD
		? undefined
		: process.env.COUNTRY
			? (process.env.COUNTRY.toUpperCase() as Country)
			: undefined;

	const country = useCountry || defaultWebCountry || DEFAULT_COUNTRY;
	const locale = country === 'SK' ? 'sk' : 'cs';
	const territory = country === 'SK' ? 'sk_SK' : 'cs_CZ';

	return {
		country,
		locale,
		territory,
	};
};

export default useInitialCountryLocale;
